<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        {{aLang.c_list}} đánh giá điểm đến an toàn
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse v-bind:visible="mData.tableRules.showFormSearch" id="myFormSearch">
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="3">
                    <el-form-item label="Đánh giá">
                      <el-input type="number" v-model="mData.tableRules.dataSearch.value['danh_gia.gia_tri']" clearable></el-input>
                    </el-form-item>
                  </b-col>
                  <b-col md="3">
                    <el-form-item label="Ngày tạo">
                      <el-date-picker
                        type="date"
                        :format="aElement.datepicker.formatDate"
                        :valueFormat="aElement.datepicker.valueFormat"
                        v-model="mData.tableRules.dataSearch.value['danh_gia.thoi_diem_tao']"
                        :placeholder="aElement.datepicker.placeholderDate"
                        clearable
                      ></el-date-picker>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                  >{{aLang.c_search}}</el-button>
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col md="12">
            <div class="text-right mb-2">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                plain
              >{{aLang.c_showHideSearch}}</el-button>
            </div>
          </b-col>
        </b-row>

        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%"
          :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
        >
          <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
          <el-table-column
            prop="ten_nguoi_danh_gia"
            label="Người đánh giá"
            min-width="200"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="diem_den_an_toan_id"
            label="Đối tượng đánh giá"
            min-width="200"
          >
              <template slot-scope="scope">
              {{scope.row.ten_diem_den_an_toan}}
            </template>
          </el-table-column>
          <el-table-column
            prop="danh_gia.gia_tri"
            :sortable="mData.tableRules.allowSorting"
            label="Đánh giá"
            width="100"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.danh_gia ? fn_formatterNumber(scope.row.danh_gia.gia_tri,1) : "" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="danh_gia.thoi_diem_tao"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm tạo"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="thoi_diem_check_in"
            :sortable="mData.tableRules.allowSorting"
            label="Thời điểm checkin"
            :formatter="fn_formatterDatetime"
            width="150"
            align="center"
          ></el-table-column>

          <el-table-column :label="aLang.c_action" align="center" width="150px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail',scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div
              v-if="mData.tableRules.allowSelect"
            >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DanhGiaDDATDetailModel from "./DanhGiaDDATDetailModel";
import CheckinDDATApi from "../../../moduleApi/CheckinDDATApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";
import TourApi from "../../../moduleApi/TourApi";
import HuongDanVienApi from "../../../moduleApi/HuongDanVienApi";
import DichVuChatLuongCaoApi from "../../../moduleApi/DichVuChatLuongCaoApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import CoSoLuuTruApi from "../../../moduleApi/CoSoLuuTruApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "DanhGiaDDATDetail", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(DanhGiaDDATDetailModel.tableRules),
        dataDefault: {
          listNguoiDanhGia: [],
          listDDAT:[],

        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (!dataFilter.filters.includes("danh_gia.gia_tri")) {
        dataFilter.filters += '&danh_gia.gia_tri>0';
      }

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        });
      }

      let res = await CheckinDDATApi.list(dataFilter);

      //get List
      let nguoiDanhGias = [];
      let doiTuongDanhGias = [];

      nguoiDanhGias = MethodService.findListItemDifferent(
        res.result,
        "nguoi_check_in_id"
      );

      doiTuongDanhGias = MethodService.findListItemDifferent(
        res.result,
        "diem_den_an_toan_id"
      );

      let resNguoiDanhGiaApi = await KhachDuLichApi.list({
        limit: nguoiDanhGias.length,
        filters: "id:in:" + nguoiDanhGias.join(",")
      });

      let resDDATApi = await DiemDenAnToanApi.list({
        limit: doiTuongDanhGias.length,
        filters: "id:in:" + doiTuongDanhGias.join(",")
      });

      this.mData.dataDefault.listNguoiDanhGia = resNguoiDanhGiaApi.result;

      this.mData.dataDefault.listDDAT = resDDATApi.result;
      //end

      this.mData.tableRules.data = this.changeData(res.result);
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
    },

    //xử lý dữ liệu đầu ra
    changeData(data) {
      $.each(data, (index, item) => {
        let nguoiDanhGia = this.mData.dataDefault.listNguoiDanhGia.find(
          element => {
            return element.id == item.nguoi_check_in_id;
          }
        );
        if (nguoiDanhGia) {
          item.ten_nguoi_danh_gia = nguoiDanhGia.ho_ten.ho_ten;
        } else {
          item.ten_nguoi_danh_gia = "";
        }

        let doiTuongDanhGia = this.mData.dataDefault.listDDAT.find(
          element => {
            return element.id == item.diem_den_an_toan_id;
          }
        );
        if (doiTuongDanhGia) {
          item.ten_diem_den_an_toan = doiTuongDanhGia.thong_tin_chung.ten;
        }
      });
      return data;
    },


    //click button
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
    },

    //event table

    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(JSON.stringify(this.mData.tableRules.dataSearch));
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterNumber(cellValue, dec) {
      if (typeof cellValue == "number") {
        if (!(dec && typeof cellValue == "number")) dec = 0;
        return cellValue
          .toFixed(dec)
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + ",");
      }
    },

    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
